import {Pipe, PipeTransform} from '@angular/core';
import {mapRichTextInlineStylesToClasses} from '../mapper/rich-text-class-mapper';

@Pipe({
	name: 'richTextClassMap',
	standalone: true,
})
export class RichTextClassMapPipe implements PipeTransform {
	public transform(value: string | null | undefined): string {
		if (!value) {
			return value ?? '';
		}

		return mapRichTextInlineStylesToClasses(value);
	}
}
